import React, { Component, Fragment } from 'react'
import { NavLink } from "react-router-dom";
import { IsAuthorize } from '../../../shared/authorization/check-access';
import { Role } from '../../../shared/authorization/enums';

interface IProps {
    id: number,
    url: string
}
export class ExtractionSchedulingRecipesTabs extends Component<IProps> {
    render() {
        return (
            <Fragment>
                <ul className="nav nav-tabs" id="myTab" role="tablist">
                    {IsAuthorize([Role.TAM, Role.Dev, Role.Support]) && <li className="nav-item">
                        <NavLink to={"/extraction-scheduling-recipe/extraction-scheduling-recipe-form/" + this.props.id} className={this.props.url == "/extraction-scheduling-recipe/extraction-scheduling-recipe-form/" ? "nav-link active" : "nav-link"} id="edit-tab" data-toggle="tab" href="#edit" role="tab"
                            aria-controls="edit" aria-selected={this.props.url == "/extraction-scheduling-recipe/extraction-scheduling-recipe-form/" ? "true" : "false"}><i className="far fa-edit"></i>&nbsp;Edit</NavLink>
                    </li>}
                    {/* {IsAuthorize([Role.TAM, Role.Dev]) &&  <li className="nav-item">
                        <NavLink to={"/extraction-scheduling-recipe/delete/" + this.props.id} className={this.props.url == "/extraction-scheduling-recipe/delete/" ? "nav-link active" : "nav-link"} id="show-tab" data-toggle="tab" href="#delete" role="tab"
                            aria-controls="delete" aria-selected={this.props.url == "/extraction-scheduling-recipe/delete/" ? "true" : "false"}><i className="far fa-trash-alt"></i>&nbsp;Delete</NavLink>
                    </li>} */}
                    {IsAuthorize([Role.TAM, Role.Dev, Role.Support]) &&  <li className="nav-item">
                        <NavLink to={"/extraction-scheduling-recipe/detail/" + this.props.id} className={this.props.url == "extraction-scheduling-recipes/detail/" ? "nav-link active" : "nav-link"} id="show-tab" data-toggle="tab" href="#show" role="tab"
                            aria-controls="show" aria-selected={this.props.url == "/extraction-scheduling-recipe/detail/" ? "true" : "false"}><i className="fas fa-info-circle"></i>&nbsp;Show</NavLink>
                    </li>}
                </ul>
                <br />
            </Fragment>
        )
    }
}
